import AreaOfUse from './AreaOfUse';
export default AreaOfUse;